export const tabTypes = ['translations', 'labels']

export const locales = ['es', 'en', 'fr', 'de', 'ca']

export const getBodyStyle = (params = {}) => {
  const { isOpen, maxHeight = 0 } = params
  return { maxHeight: isOpen ? maxHeight : 0 }
}

